<template>
  <div class="main">
    <div class="header">
      <van-cell-group>
        <van-cell center :title="shopInfo.name" @click="toRegisterMember">
          <van-icon name="add-o" /> 新增会员
        </van-cell>
      </van-cell-group>
      <div class="overview" @click="$router.push('memberList')">
        <div class="top">
          <span>会员总览</span>
          <van-icon name="arrow" />
        </div>
        <div class="bottom">
          <div class="left">
            <div class="num">{{ nemberOverview.newMemberNumber }}</div>
            <div class="text">今日新增会员</div>
          </div>
          <div class="center">
            <div class="num">{{ nemberOverview.memberNumber }}</div>
            <div class="text">全部会员</div>
          </div>
          <div class="right">
            <div class="num">{{ nemberOverview.visitorsNumber }}</div>
            <div class="text">访客</div>
          </div>
        </div>
      </div>
    </div>
    <div class="notices">
      <van-dropdown-menu active-color="#C59770">
        <van-dropdown-item
          v-if="shopInfo.isSubAccount != 'T'"
          @change="loadMembers"
          v-model="accountSelect"
          :options="accountOptions"
        />
        <van-dropdown-item
          @change="loadMembers"
          v-model="dateSelect"
          :options="dateOptions"
        ></van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <div class="memberList">
      <van-empty
        v-if="members == null || members.length == 0"
        description="没有数据"
      />
      <div v-else class="vipLise">
        <menberListCard
          v-for="(item, index) in members"
          :key="index"
          :item="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { apiPost } from "@/api/common";
import menberListCard from "./menberCard";

// 引入vant组件库
export default {
  name: "MemberCenter",
  data() {
    return {
      shopInfo: "",
      nemberOverview: "",
      accountSelect: "0",
      dateSelect: "7",
      accountOptions: [{ text: "选择账号", value: "0" }],
      dateOptions: [
        { text: "近三日", value: "3" },
        { text: "近七日", value: "7" },
        { text: "近30日", value: "30" },
      ],
      defaultImg: "https://img01.yzcdn.cn/vant/cat.jpeg",
      finished: false,
      members: "",
      query: {
        account: "",
        day: "",
        isSubAccount: "",
        memberType: "",
        mobile: "",
        nickName: "",
        queryType: "",
        shopCode: "",
        shopId: "",
        sort: "",
        startTimeEnd: "",
        startTimeStart: "",
        userName: "",
      },
    };
  },
  components: {
    menberListCard,
  },
  created() {
    this.loadComments();
    this.loadData();
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    loadData() {
      this.loadMemberOverview();
      this.loadSubaccounts();
      this.loadMembers();
    },
    //获取会员总览
    loadMemberOverview() {
      let _this = this;
      const url = "/mem/member/memberOverview";
      let isSubAccount = this.shopInfo.isSubAccount;
      let data = {
        id: this.shopInfo.id,
        isSubAccount: isSubAccount ? isSubAccount : "F",
        shopCode: this.shopInfo.shopCode,
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          _this.nemberOverview = _data.data.results;
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //查询店铺子账号
    loadSubaccounts() {
      let _this = this;
      let data = {
        accountId: this.shopInfo.id,
        shopCode: this.shopInfo.shopCode,
      };
      const url = "/api/storeSubbranch/querySubAccountList";
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          let subAccounts = _data.data.results;
          for (let i = 0; i < subAccounts.length; i++) {
            let item = {
              text: subAccounts[i].userName,
              value: subAccounts[i].id + "",
            };
            _this.accountOptions.push(item);
          }
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //加载会员查询信息
    loadMembers() {
      let _this = this;
      const url = "/mem/member/query";
      let isSubAccount = this.shopInfo.isSubAccount;
      let account = "";
      let shopId = this.shopInfo.id;
      if (this.accountSelect == 0) {
        isSubAccount = isSubAccount ? isSubAccount : "F";
      } else {
        isSubAccount = "T";
        account = this.accountSelect;
      }
      let data = {
        account: account,
        isSubAccount: isSubAccount,
        shopCode: this.shopInfo.shopCode,
        shopId: shopId,
        day: this.dateSelect,
        memberType: "register",
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          let members = _data.data.results.mbrInfoQueryVoList;
          for (let i = 0; i < members.length; i++) {
            let time = members[i].createTime + "";
            members[i].createTime = time.substring(0, 10);
          }
          _this.members = Object.freeze(members);
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //跳转到注册页面
    toRegisterMember() {
      this.$router.push("/registerMember");
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/member/memberCenter.less");
</style>

